import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Container,
  Grid,
  Typography,
  Stepper,
  Step,
  StepLabel,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import BasicInfo from "../BasicEventInfo/BasicInfo";
import InviteTeamComponent from "../InviteTeam/InviteTeam";
import ShareInviteUser from "../ShareInviteUser/ShareInviteUser";
import CreateTicket from "../CreateTicket/CreateTicket";
import {
  AllTypoFontStyles,
  addEventMainStyles,
} from "../../../../Styles/styles";
import { useNavigate } from "react-router-dom";
import {
  useCreateTicketMutation,
  useGetProfileInformationQuery,
  useGetTicketCategoryQuery,
  useTeamInvitationMutation,
} from "../../../../Redux/apis/ApiSlice";
import { notification } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { clearEditEventInfo } from "../../../../Redux/Slices/editEventInfoSlice";
import { useCreateEventMutation } from "../../../../Redux/apis/ApiSlice";
import { setInviteLink } from "../../../../Redux/Slices/inviteLinkSlice";
import { setEventId } from "../../../../Redux/Slices/eventIdSlice";
import { setEventInfo } from "../../../../Redux/Slices/eventInfoSlice";
import ticketPayloadSlice, {
  clearTicketPayload,
} from "../../../../Redux/Slices/ticketPayloadSlice";
import * as Yup from "yup";
import { setEditEventInfo } from "../../../../Redux/Slices/editEventInfoSlice";
import {
  clearEditTicket,
  setEditTicket,
} from "../../../../Redux/Slices/editTicketSlice";
import dayjs from "dayjs";
import { ErrorOutline, ErrorOutlined } from "@mui/icons-material";
const steps = ["Basic Info", "Invite Team", "Create Ticket", "Invite User"];

const AddEvent = () => {
  const [token, setToken] = useState(null);

  const [onBoarding, setOnboarding] = React.useState();
  const { data: profileData, refetch: fetchProfileData } =
    useGetProfileInformationQuery();

  const [teamInvitation] = useTeamInvitationMutation();
  const [createTicket] = useCreateTicketMutation();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [missingFields, setMissingFields] = useState([]);
  const [currentMissingField, setCurrentMissingField] = useState("");
  const [missingFieldsQueue, setMissingFieldsQueue] = useState([]);
  const [currentMissingFieldIndex, setCurrentMissingFieldIndex] = useState(0);
  const editEventIfo = useSelector((state) => state.editEventInfo.editEvent);
  const dispatch = useDispatch();
  const { data: getTicketCategory, refetch } = useGetTicketCategoryQuery();
  const [activeStep, setActiveStep] = useState(0);
  const [isBasicInfoComplete, setIsBasicInfoComplete] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const [selectedTicket, setSelectedTicket] = useState(null);
  const [eventMutation] = useCreateEventMutation();
  const [loading, setLoading] = useState(false);
  const [selectedTeams, setSelectedTeams] = useState([{ name: "", email: "" }]);
  const [selectedUsers, setSelectedUsers] = React.useState([""]);

  const inviteLink = useSelector((state) => state.inviteLink.link);
  const eventInviteType = "team";
  const eventId = useSelector((state) => state.eventId.eventId);

  const validationSchema = Yup.object({
    name: Yup.string().required("Event name is required"),
    description: Yup.string().required("Description is required"),
    location: Yup.string().optional(),
    organizationName: Yup.string().optional(),
    date: Yup.string().required("Date is required"),
    time: Yup.string().required("Time is required"),
  });
  const [errors, setErrors] = useState({});

  useEffect(() => {
    if (profileData) {
      setOnboarding(profileData.user.onBoarding);
    }
  }, [profileData]);

  const validate = async () => {
    const values = { ...eventData };
    try {
      await validationSchema.validate(values, { abortEarly: false });
      setErrors({});
      return true;
    } catch (err) {
      const validationErrors = {};
      err.inner.forEach((error) => {
        validationErrors[error.path] = error.message;
      });
      setErrors(validationErrors);
      return false;
    }
  };
  const handleBlur = async (e) => {
    const { name } = e.target;
    const fieldErrors = {};
    try {
      await validationSchema.validateAt(name, eventData);
    } catch (err) {
      fieldErrors[name] = err.message;
    }
    setErrors((prevErrors) => ({ ...prevErrors, ...fieldErrors }));
  };
  const navigate = useNavigate();
  const [eventData, setEventData] = useState({
    name: "",
    description: "",
    location: "",
    organizationName: "",
    date: "",
    time: "",
    endTime: "",
    latitude: "",
    longitude: "",
    eventPhotoUrls: [],
    startDateTime: dayjs().format("YYYY-MM-DD HH:mm"),
    endDateTime: dayjs().format("YYYY-MM-DD HH:mm"),
  });

  const updatedLink = `${inviteLink}`;

  const payload = useSelector((state) => state?.ticketPayload?.payload);
  useEffect(() => {
    if (payload?.ticketTemplate)
      setSelectedTicket({
        id: payload?.ticketTemplate,
        bgColor: payload?.color,
      });

    refetch();
  }, [refetch, getTicketCategory]);

  const ticketTemplate = useSelector((state) => state?.sele);

  const validateTimes = (startTime, endTime) => {
    return dayjs(startTime).isBefore(dayjs(endTime));
  };

  /**
   * Checks if a given Dayjs date object is complete.
   * @param date - The Dayjs date object to check.
   * @returns {boolean} - Returns true if the date is complete, otherwise false.
   */
  const isDateComplete = (date) => {
    if (!date) return false; // Ensure date is not null
    date = dayjs(date);
    // Check all date components are valid
    const hasYear = date.year() > 0; // Year must be greater than 0
    const hasMonth = date.month() >= 0; // Month must be 0-11 (January is 0)
    const hasDay = date.date() > 0; // Day must be > 0
    const hasHour = date.hour() >= 0; // Hour must be 0-23
    const hasMinute = date.minute() >= 0; // Minute must be 0-59
    return hasYear && hasMonth && hasDay && hasHour && hasMinute;
  };

  const handleNext = async () => {
    if (activeStep === 0) {
      setLoading(true);
      let missing = [];
      if (eventData.name === "") missing.push("Event Name");

      if (eventData.description === "") missing.push("Description");
      // if (eventData.latitude === "" || eventData.longitude === "")
      //   missing.push("Location");
      //if (eventData.organizationName === "") missing.push("Organization Name");
      if (eventData.startDateTime === "") missing.push("Start Date & Time");
      if (eventData.endDateTime === "") missing.push("End Date & Time");
      if (!isDateComplete(eventData.startDateTime)) {
        missing.push("Please enter complete start time");
      }
      if (!isDateComplete(eventData.endDateTime)) {
        missing.push("Please enter complete end time");
      }
      if (
        isDateComplete(eventData.startDateTime) &&
        isDateComplete(eventData.endDateTime) &&
        !validateTimes(eventData.startDateTime, eventData.endDateTime)
      ) {
        missing.push("End time must be after start time.");
      }

      if (missing.length > 0) {
        setMissingFieldsQueue(missing);
        setCurrentMissingField(missing[0]); // Show first missing field
        setOpenDialog(true);
        return;
      }

      try {
        const isValid = await validate();
        const eventPayload = {
          eventId: editEventIfo?.event?.eventId,
          eventName: eventData.name,
          description: eventData.description,
          location: eventData.location,
          organizationName: eventData.organizationName,
          date: eventData.date,
          time: eventData.time,
          endTime: eventData.endTime,
          latitude: eventData.latitude,
          longitude: eventData.longitude,
          eventPhotoUrls: eventData.eventPhotoUrls,
          startDateTime: eventData.startDateTime,
          endDateTime: eventData.endDateTime,
        };
        const response = await eventMutation(eventPayload).unwrap();
        dispatch(setEditEventInfo(response));

        dispatch(setInviteLink(response.inviteLink));
        dispatch(setEventId(response.event.eventId));
        dispatch(setEventInfo(response.event));

        setActiveStep((prevActiveStep) => prevActiveStep + 1);
      } catch (error) {
        notification.error({
          message: "Error submitting event!",
          // description: error.data?.message || error.message,
        });
        console.error("Error submitting event:", error);
        setActiveStep(0);
      } finally {
        setLoading(false);
      }
    } else if (activeStep === 1) {
      const roleId = 2;
      const userData = localStorage.getItem("userData");
      const parsedData = JSON.parse(userData);

      // Extract the email from local storage
      const userEmail = parsedData?.email;
      setLoading(true);

      // Keep track of valid invitations to send
      const emailsToSend = [];
      let hasError = false; // To track if there was an error sending an invitation
      let emailSent = false;
      let errorMessages = []; // To track all error messages from the API

      try {
        // for (let email of selectedTeams) {
        //   if (!email || email === "") continue;

        //   // Check if the email matches the user's email
        //   if (email === userEmail) {
        //     // Show an error notification if the user is trying to send an invite to themselves
        //     notification.error({
        //       message: "You cannot send an invitation to yourself!",
        //     });
        //     hasError = true; // Set error flag to true
        //     continue; // Skip sending to this email
        //   }

        //   const invitationData = {
        //     email: email,
        //     link: updatedLink, // invitation link from the state
        //     eventId: eventId,
        //     roleId: roleId,
        //     eventInviteType: eventInviteType,
        //   };

        //   // Collect emails to send
        //   emailsToSend.push(invitationData);
        // }
        for (let entry of selectedTeams) {
          const { name, email, lastName } = entry;
          if (!email || email === "") continue;

          if (email === userEmail) {
            notification.error({
              message: "You cannot send an invitation to yourself!",
            });
            hasError = true;
            continue;
          }

          const invitationData = {
            email,
            name,
            lastName,
            link: inviteLink,
            eventId,
            roleId,
            eventInviteType: "user",
          };

          emailsToSend.push(invitationData);
        }

        // If there are no valid emails to send, handle that case
        if (emailsToSend.length === 0 && hasError) {
          return; // Exit early if there are no valid emails
        }

        // Send invitations for valid emails only
        for (let invitationData of emailsToSend) {
          try {
            const response = await teamInvitation(invitationData); // mutation for each valid email
            // Check if the API responded with an error message
            if (response.data?.alreadySent === true) {
              // errorMessages.push(`Invitation has already been sent to this email for this event.`);
              notification.warning({
                message: response.data?.message, // Show all error messages
              });
              hasError = true;
            }
          } catch (error) {
            console.error(
              "Failed to send invitation for:",
              invitationData.email,
              error
            );
            // errorMessages.push(`Error for ${invitationData.email}: ${error.message}`);
            hasError = true;
          }
        }

        // Notify success only if there were no errors
        if (emailsToSend.length > 0 && !hasError) {
          notification.success({
            message: "Invitations sent successfully!",
          });
        } else if (hasError) {
          // Display a collective error message for any failures
          // notification.error({
          //   message: "Failed to send some invitations",
          //   description: errorMessages, // Show all error messages
          // });
        }
      } catch (error) {
        console.error("Failed to send invitations:", error);
        alert("An error occurred while sending invitations.");
      } finally {
        setLoading(false); // Set loading to false after the operation completes
        setSelectedTeams([{ name: "", email: "" }]);
        setActiveStep((prevActiveStep) => prevActiveStep + 1);
      }
    } else if (activeStep === 2) {
      setLoading(true); // Set loading to true at the beginning of the operation
      if (!payload) {
        notification.error({
          message: "No ticket payload found!",
        });
        setLoading(false); // Ensure loading is set to false if there is no payload
        return;
      }

      // Create ticket and handle response
      createTicket(payload)
        .unwrap()
        .then((response) => {
          notification.success({
            message: "Ticket created successfully!",
          });
          if (response?.ticket?.ticketId) {
            dispatch(setEditTicket(response.ticket.ticketId));
          }

          setActiveStep((prevActiveStep) => prevActiveStep + 1);
        })
        .catch((error) => {
          notification.error({
            message: "Choose ticket template to proceed!",
          });
          console.error("Error creating ticket:", error);
        })
        .finally(() => {
          setLoading(false); // Always set loading to false after the operation completes
        });
    }
  };

  const handleDialogNext = () => {
    if (currentMissingFieldIndex < missingFields.length - 1) {
      setCurrentMissingFieldIndex((prev) => prev + 1);
    } else {
      setOpenDialog(false);
      setLoading(false);
    }
  };

  const handleBack = () => {
    /*   if (selectedTicket && activeStep === 2) {
      setSelectedTicket(null);
    } else {
      setActiveStep((prevActiveStep) => prevActiveStep - 1);
    } */

    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleSubmit = async () => {
    if (
      onBoarding === false &&
      payload?.ticketType?.some((item) => item.price > 0)
    ) {
      setIsModalOpen(true);
      return;
    }

    const roleId = 3;
    const userData = localStorage.getItem("userData");
    const parsedData = JSON.parse(userData);

    // Extract the user's email from local storage
    const userEmail = parsedData?.email;
    setLoading(true);

    // Keep track of valid invitations to send
    const emailsToSend = [];
    let hasError = false;

    try {
      for (let user of selectedUsers) {
        const email = user?.email;
        const name = user?.name;
        const lastName = user?.lastName;

        if (!email || email === "") continue;

        if (email === userEmail) {
          notification.error({
            message: "You cannot send an invitation to yourself!",
          });
          hasError = true;
          continue;
        }

        const invitationData = {
          email: email,
          name: name,
          lastName: lastName,
          link: inviteLink,
          eventId: eventId,
          roleId: roleId,
          eventInviteType: "user",
        };

        emailsToSend.push(invitationData);
      }

      if (emailsToSend.length === 0 && hasError) {
        setLoading(false); // Set loading to false before exiting
        return; // Do not proceed further
      }

      for (let invitationData of emailsToSend) {
        try {
          const response = await teamInvitation(invitationData); // mutation for each valid email
          if (
            response?.error?.data.message ===
            "Invitation already sent to this email"
          ) {
            notification.error({
              message: "Invitation already sent to this email!", // Show all error messages
            });
            hasError = true;
          }
        } catch (error) {
          console.error(
            "Failed to send invitation for:",
            invitationData.email,
            error
          );
          hasError = true;
        }
      }

      notification.success({
        message: "Event created successfully!",
      });
    } catch (error) {
      console.error("Failed to send invitations:", error);
      notification.error({
        message: "An error occurred while sending invitations!",
      });
    } finally {
      setLoading(false); // Set loading to false after the operation completes
    }

    // Navigate and clear state after the process completes
    navigate("/eventmanagement");
    dispatch(clearEditTicket());
    dispatch(clearEditEventInfo());
    dispatch(clearTicketPayload());
  };

  const handleReset = () => {
    setActiveStep(0);
  };

  const handleDialogClose = (proceed) => {
    setOpenDialog(false);
    if (proceed) {
      setActiveStep((prevActiveStep) => prevActiveStep + 1);
    }
  };

  const handleTicketSelect = (ticket) => {
    setSelectedTicket(ticket);
  };
  const colors = [
    "#B5F6FB",
    "#E1BD5C",
    "#DADAE6",
    "#EDE6D8",
    "#E4A7CD",
    "#7F8BA1",
  ];

  const handleModalClose = () => {
    setIsModalOpen(false);

    dispatch(clearEditTicket());
    dispatch(clearEditEventInfo());
    dispatch(clearTicketPayload());

    navigate("/eventmanagement");
  };

  const handleModalConfirm = () => {
    // Redirect to settings page
    const state = { from: "login" };
    sessionStorage.setItem("navigationState", JSON.stringify(state));
    window.open("/settings", "_blank");
    setIsModalOpen(false);
  };

  return (
    <Grid
      xs={12}
      sm={12}
      md={12}
      lg={12}
      sx={{ ...addEventMainStyles.MainContainerGrid }}
    >
      <Grid
        item
        xs={12}
        sm={12}
        md={12}
        lg={12}
        sx={{ ...addEventMainStyles.GridWrap }}
      >
        <Grid elevation={1} sx={{ ...addEventMainStyles.MainPaper }}>
          <Container sx={addEventMainStyles.StepsContainer}>
            <Stepper activeStep={activeStep} alternativeLabel>
              {steps.map((label) => (
                <Step key={label}>
                  <StepLabel>{label}</StepLabel>
                </Step>
              ))}
            </Stepper>
          </Container>

          <Box sx={{ ...addEventMainStyles.StepsCompleteBox }}>
            {activeStep === steps.length ? (
              <Box>
                <Typography sx={AllTypoFontStyles.EventTypo}>
                  All steps completed - you're finished
                </Typography>
                <Button onClick={handleReset}>Reset</Button>
              </Box>
            ) : (
              <Box>
                <Grid spacing={2}>
                  {activeStep === 0 && (
                    <BasicInfo
                      eventData={eventData}
                      setEventData={setEventData}
                      onNext={setIsBasicInfoComplete}
                      setLoading={setLoading}
                      handleBlur={handleBlur}
                      errors={errors}
                    />
                  )}

                  {activeStep === 1 && (
                    <InviteTeamComponent
                      token={token}
                      selectedTeams={selectedTeams}
                      setSelectedTeams={setSelectedTeams}
                      updatedLink={updatedLink}
                      inviteLink={inviteLink}
                    />
                  )}

                  {activeStep === 2 && (
                    <CreateTicket
                      colors={colors}
                      selectedTicket={selectedTicket}
                      onTicketSelect={handleTicketSelect}
                      onBack={handleBack}
                    />
                  )}

                  {activeStep === 3 && (
                    <ShareInviteUser
                      selectedTeams={selectedUsers}
                      setSelectedTeams={setSelectedUsers}
                    />
                  )}
                </Grid>
                <Box
                  sx={{
                    ...addEventMainStyles.StepsBtnBox,
                    backgroundColor: "white",
                    width: "100%",
                    borderTop: { xs: "0px", sm: "1px solid #e0e0e0" },
                  }}
                >
                  <Button
                    disabled={activeStep === 0}
                    onClick={handleBack}
                    sx={{
                      ...addEventMainStyles.BkBtnStyles,
                      backgroundColor: "white",
                      color: "black",
                      "&:hover": {
                        backgroundColor: "var(--primary-color)",
                        color: "white",
                      },
                    }}
                  >
                    Back
                  </Button>
                  {loading ? (
                    <Button
                      sx={addEventMainStyles.NextBtnStyles}
                      variant="contained"
                    >
                      Processing
                    </Button>
                  ) : (
                    <Button
                      sx={addEventMainStyles.NextBtnStyles}
                      variant="contained"
                      onClick={
                        activeStep === steps.length - 1
                          ? handleSubmit
                          : handleNext
                      }
                    >
                      {activeStep === steps.length - 1 ? "Finish" : "Next"}
                    </Button>
                  )}
                </Box>
              </Box>
            )}
          </Box>
        </Grid>
      </Grid>
      <Dialog
        open={openDialog}
        onClose={(event, reason) => {
          if (reason === "backdropClick") {
            return;
          }
          setOpenDialog(false);
        }}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          Incomplete Required Fields
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Please complete the following required fields before proceeding:
          </DialogContentText>

          <List>
            {missingFieldsQueue.map((field, index) => (
              <ListItem
                key={index}
                sx={{ alignItems: "center", paddingY: 0.5 }}
              >
                <ListItemIcon sx={{ minWidth: "30px", marginRight: "-4px" }}>
                  <ErrorOutlined color="error" fontSize="small" />
                </ListItemIcon>
                <ListItemText primary={field} sx={{ margin: 0 }} />
              </ListItem>
            ))}
          </List>
        </DialogContent>

        <DialogActions>
          <Button
            sx={addEventMainStyles.BkBtnStyles}
            onClick={() => {
              handleDialogClose(false);
              setLoading(false);
            }}
          >
            Okay
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={isModalOpen}
        onClose={handleModalClose}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle sx={{ fontWeight: "bold" }}>
          Payment Integration Required
        </DialogTitle>
        <DialogContent dividers>
          <Typography variant="body1" gutterBottom>
            You are creating a <strong>paid event</strong>, but your payment
            method is not yet integrated.
          </Typography>
          <Typography variant="body2" color="textSecondary">
            <strong>Note:</strong> If you do not integrate a payment method,
            this event will not be published. You can skip this step now and
            connect later to republish your event.
          </Typography>
        </DialogContent>
        <DialogActions sx={{ justifyContent: "space-between", p: 2 }}>
          <Button onClick={handleModalClose} variant="outlined" color="primary">
            Skip for Now
          </Button>
          <Button
            onClick={handleModalConfirm}
            variant="contained"
            color="primary"
            autoFocus
          >
            Connect Payment Now
          </Button>
        </DialogActions>
      </Dialog>
    </Grid>
  );
};

export default AddEvent;
